import type {IRootMachineSnapshot} from '../machines/rootMachine/rootMachine';


export const selectTimezone = (state: IRootMachineSnapshot): string => {
  return state.context.timezone as string;
};
